<template>
  <section id="services" class="mb-20 padding-x">
    <div class="flex flex-col w-full">
      <h3
        id="what-i-do"
        v-html="whatIDo"
        class="font-extrabold uppercase heading-1"
      ></h3>

      <div
        id="services-text"
        class="justify-end grid lg:grid grid-cols-12 grid-gap opacity-0 mt-[5%] text-flax-smoke-300"
      >
        <p
          class="col-span-4 col-start-0 md:col-start-4 text-flax-smoke-300/85 text-center text-nowrap heading-6"
        >
          ( SERVICES )
        </p>
        <p
          class="col-span-8 md:col-span-5 w-full font-fancy sm:font-semibold text-balance heading-4"
        >
          User-Friendly interface don't happen by chance, they are built with
          intention. I code intuitive responsive solutions that make your users'
          journey effortless
        </p>
      </div>
    </div>

    <div class="relative mt-12 lg:mt-[10%] w-full">
      <div class="flex flex-col justify-between gap-y-16 mt-12">
        <ServicesCard
          v-for="(card, index) in servicesCardProps"
          :key="index"
          :number="index + 1"
          :title="card.title"
          :body="card.body"
          :headings="card.headings"
          :shape="card.shape"
          class="sticky bg-[#0B0B0A] border-flax-smoke-500/50 border-t"
          :class="getStyle(index)"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { animateSplitText } from '@/animations';
  import { textSplitterIntoChar } from '@/functions';
  import { onBeforeMount, onMounted, ref } from 'vue';
  import { ServicesCard } from '..';

  const whatIDo = ref('My services /');

  const servicesCardProps = [
    {
      title: 'Web Development',
      body: 'I craft custom WordPress solutions from front-end to back-end tailored to elevate your brand. My focus is on performance, security, seamless user experience, and clean, scalable code for long-term flexibility.',
      headings: [' Full-Stack WordPress Development', 'Performance & Security', 'Scalable & Maintainable Code'],
      shape: `<svg viewBox="0 0 200 200"  xmlns="http://www.w3.org/2000/svg">
  <path d="M100 0C103.395 53.7596 146.24 96.6052 200 100C146.24 103.395 103.395 146.24 100 200C96.6052 146.24 53.7596 103.395 0 100C53.7596 96.6052 96.6052 53.7596 100 0Z"/>
  </svg>
  `,
    },
    {
      title: 'Advanced Solutions',
      body: 'I specialize in building robust, full-stack web applications that streamline business workflows, connect systems, and create seamless digital experiences delivering both frontend finesse and backend power.',
      headings: [
        'End-to-End Web Apps',
        'API & System Integrations',
        'Scalable, Future-Ready Architecture',
      ],
      shape: `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <path d="M127.14 200C99.9942 200 99.9943 167.423 72.8487 167.423C41.6048 167.423 0 158.386 0 127.133C0 99.9885 32.5678 99.9885 32.5678 72.8445C32.5678 41.6139 41.6048 0 72.8602 0C100.006 0 100.006 32.5774 127.151 32.5774C158.384 32.5774 200 41.6139 200 72.8675C200 100.012 167.421 100.012 167.421 127.156C167.409 158.444 158.384 200 127.14 200Z" />
  </svg>
  `,
    },
    {
      title: 'Code Optimization',
      body: 'I ensure your web application is fast, responsive, and efficient from front-end performance to back-end logic. Through smart coding practices, optimized queries, and responsive layouts, I help your site perform at its best.',
      headings: [
        'Clean & Scalable Code',
        'Responsive & Accessible UI',
        'Backend Performance Tuning',
      ],
      shape: `<svg  viewBox="0 0 200 200"  xmlns="http://www.w3.org/2000/svg">
  <path d="M100 0L170.711 29.2893L200 100L170.711 170.711L100 200L29.2893 170.711L0 100L29.2893 29.2893L100 0Z" />
  </svg>
  `,
    },
  ];

  onBeforeMount(() => {
    whatIDo.value = textSplitterIntoChar('What I do /', true);
  });

  onMounted(() => {
    animateSplitText('#what-i-do .letters', '#services-text', 0.7, 0.01, 0);
  });

  const getStyle = (index: number) => {
    if (index === 0) {
      return 'top-[calc(20vh_+_0em)] mb-[17.25em]';
    }

    if (index === 1) {
      return 'top-[calc(20vh_+_5.75em)] mb-[11.5em]';
    }

    if (index === 2) {
      return 'top-[calc(20vh_+_11.5em)] mb-[5.75em]';
    }
  };
</script>
